import React, { Component } from 'react';
import { connect } from 'react-redux';
import { initialize } from 'redux-form';
import { loadTrialLessons, deleteTrialLesson } from './actions';
import Filter from './Filter';
import List from './List';
import authUtils from '../../auth/utils';

class TrialLessons extends Component {
	constructor(props) {
		super(props);
		this.handleFilterSubmit = this.handleFilterSubmit.bind(this);
		this.handleFilterReset = this.handleFilterReset.bind(this);
		this.handleListEvent = this.handleListEvent.bind(this);
		this.handleDelete = this.handleDelete.bind(this);
	}

	componentDidMount() {
		const { filter, sortKey, sortDirection, pageNumber, pageSize } = this.props.pagination;
		this.loadData({ filter, sortKey, sortDirection, pageNumber, pageSize });
		this.props.initializeFilter(filter);
	}

	loadData({ filter, sortKey, sortDirection, pageNumber, pageSize }) {
		if (!filter) {
			filter = {};
		}
		filter.canceled = 'false'; 
		
		this.props.loadEntities({...filter, sortKey, sortDirection, pageSize, pageNumber});
	}

	handleFilterSubmit(filter) {
		const { sortKey, sortDirection, pageNumber, pageSize } = this.props.pagination;
		this.loadData({ filter, sortKey, sortDirection, pageNumber: 1, pageSize });
	}

	handleFilterReset() {
		this.handleFilterSubmit({});
	}

	handleListEvent(listPagination) {
		const { filter } = this.props.pagination;
		this.loadData({ filter, ...listPagination });
	}

	handleDelete(id) {
		const onSuccessEvent = () => this.reloadData();
		this.props.deleteTrialLesson(id, onSuccessEvent);
	}

	reloadData() {
		const { filter, sortKey, sortDirection, pageNumber, pageSize } = this.props.pagination;		
		this.loadData({ filter, sortKey, sortDirection, pageNumber, pageSize });
	}

	render() {
		const { isReadonly } = this.props;
		return (
			<div>
				<Filter onSubmit={this.handleFilterSubmit} onReset={this.handleFilterReset} loading={this.props.pagination.loading} />
				<List isReadonly={isReadonly} onFetchData={this.handleListEvent} onDelete={this.handleDelete} data={this.props.data} {...this.props.pagination} />
			</div>
		);
	}
}

const mapStateToProps = state => {
	const {
		pagination,
		entities: { trialLessons },
		auth: { currentUser }
	} = state;

	const trialLessonsPagination = pagination.trialLessons.all || { ids: [], pageNumber: 1, pageSize: 10 };

	return {
		data: trialLessonsPagination.ids.map(id => trialLessons[id]),
		pagination: trialLessonsPagination,
		isReadonly: authUtils.hasReadOnlyPermission(currentUser, 'TrialLessons')
	};
};

export default connect(mapStateToProps, {
	loadEntities: loadTrialLessons,
	deleteTrialLesson: deleteTrialLesson,
	initializeFilter: (data, fields) => initialize('trialLessonsFilter', data, fields)
})(TrialLessons);